export default function(scheduleDateVal, scheduleTimeVal) {
  let scheduleTime = "";
  let scheduleDate = "";
  const scheduleTimeProp = scheduleTimeVal;
  const scheduleDateProp = scheduleDateVal;

  scheduleTime = `${(scheduleTimeProp.hours <= 9
    ? scheduleTimeProp.hours == 0
      ? "12"
      : `${scheduleTimeProp.hours}`
    : `${
        scheduleTimeProp.hours <= 12
          ? scheduleTimeProp.hours
          : scheduleTimeProp.hours - 12
      }`) +
    ":" +
    (scheduleTimeProp.minutes <= 9
      ? `0${scheduleTimeProp.minutes}`
      : scheduleTimeProp.minutes) +
    `${scheduleTimeProp.hours < 12 ? "am" : "pm"}`}`;

  scheduleDate =
    scheduleDateProp.year +
    "-" +
    (scheduleDateProp.month < 10
      ? `0${scheduleDateProp.month}`
      : scheduleDateProp.month) +
    "-" +
    (scheduleDateProp.day < 10
      ? `0${scheduleDateProp.day}`
      : scheduleDateProp.day);

  return {
    scheduleDate,
    scheduleTime
  };
}
